<template>
  <SimpleEmailForm :error="error" :is-loading="isLoading" @send="send" />
</template>
<script>
import axios from "axios";
import toRequestBody from "./api/calculatorResultsMapper";
import SimpleEmailForm from "../SimpleEmailForm.vue";

export default {
  name: "PaintCalculatorEmailForm",

  components: { SimpleEmailForm },

  props: {
    interior: {
      type: Boolean,
      required: true,
    },
    newJob: {
      type: Boolean,
      required: true,
    },
    quantities: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      error: false,
      isLoading: false,
    };
  },

  methods: {
    getCsrfToken() {
      return {
        [this.$root.getCsrfTokenName()]: this.$root.getCsrfTokenValue(),
      };
    },

    send(email) {
      if (this.isLoading) return;

      this.error = false;
      this.isLoading = true;

      const { interior, newJob, quantities } = this;
      const csrf = this.getCsrfToken();

      axios
        .post(
          `/paint-calculator/send`,
          toRequestBody({ csrf, interior, newJob, quantities, email })
        )
        .then((res) => {
          if (res.status !== 201) throw new Error();
          this.isLoading = false;
          this.$emit("close");
        })
        .catch(() => {
          this.error = "Unable to send email, please try again later";
          this.isLoading = false;
        });
    },
  },
};
</script>
